import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import PasswordGate from "@/components/PasswordGate";
import Dashboard from "@/pages/Dashboard";
import GroupsPage from "@/pages/GroupsPage";
import RosterPage from "@/pages/RosterPage";
import BusesPage from "@/pages/BusesPage";
import CITPage from "@/pages/CITPage";
import AMPMPage from "@/pages/AMPMPage";
import AdminPage from "@/pages/AdminPage";
import LetterView from "@/pages/LetterView";

function App() {
  return (
    <PasswordGate>
      <div className="App">
        <BrowserRouter>
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              style: {
                fontFamily: "Manrope, sans-serif",
                borderRadius: "12px",
              },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/groups" element={<GroupsPage />} />
              <Route path="/roster" element={<RosterPage />} />
              <Route path="/buses" element={<BusesPage />} />
              <Route path="/cit" element={<CITPage />} />
              <Route path="/ampm" element={<AMPMPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/letter/:type/:id?" element={<LetterView />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </PasswordGate>
  );
}

export default App;
